/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import {chatInfoRoute} from './chat-button.configs';

export async function reqInfoChat() {	
    const response = await axios.get(chatInfoRoute);
    return response.data;    
}
